import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid } from "recharts";

export default function WaitHistogram({ data = [], bin = 5 }) {
  const isDark = typeof window !== "undefined" &&
                 window.matchMedia &&
                 window.matchMedia("(prefers-color-scheme: dark)").matches;

  const COLORS = {
    grid: isDark ? "#2b2b2b" : "#e5e7eb",
    tick: isDark ? "#e5e7eb" : "#1f2937",
    bar:  isDark ? "#34d399" : "#10b981",
    tooltipBg: isDark ? "#1a1a1a" : "#ffffff",
    tooltipBorder: isDark ? "#333" : "#ddd",
  };

  const rows = data.map(r => ({
    bucket: `${r.bucket_start}-${Number(r.bucket_start)+bin}s`,
    cnt: Number(r.cnt)
  }));

  return (
    <div style={{height:300}}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={rows}>
          <CartesianGrid stroke={COLORS.grid} />
          <XAxis
            dataKey="bucket"
            interval={0}
            angle={-20}
            textAnchor="end"
            height={70}
            tick={{ fill: COLORS.tick }}
          />
          <YAxis tick={{ fill: COLORS.tick }} />
          <Tooltip
            contentStyle={{ background: COLORS.tooltipBg, border: `1px solid ${COLORS.tooltipBorder}`, color: COLORS.tick }}
            labelStyle={{ color: COLORS.tick }}
          />
          <Bar dataKey="cnt" fill={COLORS.bar} fillOpacity={0.95}/>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
